// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"856":"3f3efd03","995":"76d229d7"}[chunkId] + ".js";
};